<dialog class="lib-dialog" #dialog>
  <div class="lib-dialog__wrapper">
    <div class="lib-dialog__header">
      {{ titleText }}
      @if (!hideCancelCross) {
        <button [ngClass]="[buttonClass, buttonClass+'--icon']" class="lib-dialog__header-close"
                (click)="cancelClick()">
          <span class="material-symbols-outlined">close</span>
        </button>
      }
    </div>
    <div class="lib-dialog__content">
      @if (messageText) {
        <p [innerHTML]="messageText"></p>
      }
      <ng-content></ng-content>
    </div>
    <div class="lib-dialog__footer">
      @if (hasOkCancelButton) {
        <button class="glob-button--primary" [ngClass]="buttonClass" (click)="okClick()">
          <strong>{{ okText }}</strong>
        </button>
        <button class="glob-button--secondary glob-button--no-margin" [ngClass]="buttonClass"
                (click)="cancelClick()">{{ cancelText }}
        </button>
      } @else if (hasOkButton) {
        <button class="glob-button--primary" [ngClass]="buttonClass" (click)="okClick()">
          <strong>{{ okText }}</strong>
        </button>
      } @else {
        <button [ngClass]="buttonClass" (click)="cancelClick()">{{ closeText }}</button>
      }
    </div>
  </div>
</dialog>
